import React from 'react';

/**
 * Modern Card Component
 * Glassmorphism card with optional hover effects
 */
export const ModernCard = ({ 
  children, 
  className = '', 
  hover = false,
  onClick,
  gradient = false,
  gradientColor = 'blue'
}) => {
  const gradientStyles = {
    blue: 'bg-gradient-to-br from-blue-600/20 to-blue-600/5 border-blue-500/20',
    emerald: 'bg-gradient-to-br from-emerald-600/20 to-emerald-600/5 border-emerald-500/20',
    violet: 'bg-gradient-to-br from-violet-600/20 to-violet-600/5 border-violet-500/20',
    amber: 'bg-gradient-to-br from-amber-600/20 to-amber-600/5 border-amber-500/20',
  };

  const baseClass = gradient 
    ? `${gradientStyles[gradientColor]} backdrop-blur-xl rounded-2xl border p-6`
    : 'bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-6';

  const hoverClass = hover ? 'hover:bg-white/10 hover:scale-[1.02] cursor-pointer transition-all duration-200 group' : '';

  return (
    <div 
      className={`${baseClass} ${hoverClass} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default ModernCard;

